module.exports = __webpack_public_path__ + "img/3.1bf531e6.png";